import styled from "styled-components";

export default styled.div`
  font-size: 11px;
  font-weight: 700;
  color: #6d8694;
  flex-direction: row;
`;
